import { sessionApiClient } from "@planningcenter/cc-api-client"
import {
  QueryClient,
  QueryClientProvider,
  QueryFunctionContext,
} from "@tanstack/react-query"
import { APIErrorRecord } from "./shared/types"

const defaultQueryFn = ({ queryKey }: QueryFunctionContext) => {
  const [path, queryParams = {}] = queryKey
  return sessionApiClient.get(path, queryParams).catch((error: Error) => error)
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: defaultQueryFn,
      throwOnError: (error: Error | APIErrorRecord) =>
        ["500"].includes((error as APIErrorRecord).status),
      staleTime: 60 * 1000,
      gcTime: 60 * 5 * 1000,
    },
  },
})

export function ReactQueryProvider({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  )
}
